export const typeLabels: Record<string, string> = {
  daily: "ວຽກປະຈໍາ",
  opening: "ເປີດຮ້ານ",
  closing: "ປິດຮ້ານ",
  packing: "ແພັກສິນຄ້າ",
  qc: "QC",
};

export const statusLabels: Record<string, string> = {
  active: "ໃຊ້ງານ",
  draft: "ປັບປຸງ",
  inactive: "ບໍ່ໃຊ້ງານ",
};

export const scheduleTypeLabels: Record<string, string> = {
  daily: "ທຸກວັນ",
  opening: "ເປີດຮ້ານ",
  closing: "ປິດຮ້ານ",
  scheduled: "ຕາມກຳນົດ",
};

export const scheduleFrequencyLabels: Record<string, string> = {
  daily: "ທຸກວັນ",
  weekly: "ທຸກອາທິດ",
  monthly: "ທຸກເດືອນ",
};

export const scheduleDayOfWeekLabels: Record<number, string> = {
  1: "ວັນຈັນ",
  2: "ວັນອັງຄານ",
  3: "ວັນພຸດ",
  4: "ວັນພະຫັດ",
  5: "ວັນສຸກ",
  6: "ວັນເສົາ",
  7: "ວັນອາທິດ",
};
